import type { SystemRole } from '@/hooks/useAcl';


export const ADMIN_DASHBOARD_ROUTE = '/dashboard/admin';
export const TEACHER_DASHBOARD_ROUTE = '/dashboard/teacher-dashboard';
export const THERAPIST_DASHBOARD_ROUTE = '/dashboard/therapist';


const ROLE_HOME_ROUTES: Readonly<Record<string, string>> = {
  'Super Admin':  ADMIN_DASHBOARD_ROUTE,
  'Admin':        ADMIN_DASHBOARD_ROUTE,
  'Coordinator':  ADMIN_DASHBOARD_ROUTE,
  'Teacher':      TEACHER_DASHBOARD_ROUTE,
  'Therapist':    THERAPIST_DASHBOARD_ROUTE,
  'Parent':       ADMIN_DASHBOARD_ROUTE,
  'Student':      ADMIN_DASHBOARD_ROUTE,
  'Accountant':   ADMIN_DASHBOARD_ROUTE,
  'Librarian':    ADMIN_DASHBOARD_ROUTE,
  'Receptionist': ADMIN_DASHBOARD_ROUTE,
};

const FALLBACK_HOME_ROUTE = ADMIN_DASHBOARD_ROUTE;

/** Reverse index — dashboard route → roles that live there. */
const ROUTE_ROLES: Readonly<Record<string, readonly SystemRole[]>> = Object.entries(
  ROLE_HOME_ROUTES,
).reduce<Record<string, SystemRole[]>>((acc, [roleName, route]) => {
  (acc[route] ??= []).push(roleName);
  return acc;
}, {});

export function getRoleHomeRoute(role: SystemRole): string {
  return ROLE_HOME_ROUTES[role] ?? FALLBACK_HOME_ROUTE;
}

export function getRolesForRoute(route: string): readonly SystemRole[] {
  return ROUTE_ROLES[route] ?? [];
}

/** True for any dashboard that is some role's landing page. */
export function isRoleHomeRoute(route: string): boolean {
  return getRolesForRoute(route).length > 0;
}
